<template>
  <div class="navigator-bar-container">
    
      <template  v-for="(item, index) in buttonConfig">
        <li
          v-show="isSpread"
          class="button-one"
          rel="external nofollow"
          :key="`${item.id}-${index}`"
          @click="goAnchor(`#${item.id}`)"
        >{{item.name}}</li>
      </template>
    
    <li class="button-one" @click="backTop">
      <span><img src="/img/fund/button_top.png" alt class="button_top" /> </span>  回到顶部
    </li>
    <li
      :class="['button-one',isSpread?'el-icon-arrow-up':'el-icon-arrow-down']"
      style="border-bottom: none !important;"
      @click="showSpread"
    >
      {{ isSpread ?'收起':'展开' }}
    </li>
  
  </div>
</template>
<script>
export default {
  name: 'NavigatorBar',
  data() {
    return {
      activeId: '',
      boxShow:false,
      isSpread:true
    }
  },
  props: {
    /**
     * [{
     *  id: '',
     *  name: ''
     * }]
     */
    buttonConfig: {
      required: true,
      type: Array
    },
    rootId: {
      default: '',
      type: String
    }    
  },
  methods: {
    showSpread(){
       this.isSpread=!this.isSpread
    },
    backTop() {
      // document.body.scrollIntoView({
      //   behavior: "smooth",
      //   block: "start"
      // });
      document.querySelector(`#${this.rootId}`).scrollIntoView({
        behavior: "smooth"
      });      
    },
    goAnchor(selector) {
      document.querySelector(selector).scrollIntoView({
        behavior: "smooth"
      });
    },
  }

}
</script>
<style lang="scss" scoped>
.navigator-bar-container{
  position: fixed;
  right: 20px;
  top: calc( 50% - 200px);
  width: 110px;
  // height: 400px;
  background-color: #fff;
  border: 1px solid #e9e9e9;
  z-index: 2000;
  padding: 0px 15px;
  .button-active{
    color: #409eff;
    background-color: #ecf5ff;
  }
  .button-one{
    display: block;
    width: 100%;
    line-height: 38px;
    text-align: center;
    color: #333;
    font-size: 13px;
    border-bottom: 1px solid #f2f2f2;
    .button_top {
       width:16px;
       height:16px;
    }
  }
  .button-one:hover{
    text-decoration: underline;
    color: #409eff;
    cursor: pointer;
  }
}
// .v-enter-active, .v-leave-active{
//   transition: all 0.5s ease;
// }
// .v-enter, .v-leave-to{
//   opacity: 0.4;
//   // display: none;
// }
</style>